exports.install = function (Vue, options) {
  //isUndefined
  Vue.filter("isUndefined", function (v) {
    if (typeof v == "undefined") return true;
    else return false;
  });
  //money 过滤器
  Vue.filter("currency", function (v, type, solt) {
    var newv = "";
    var s = Vue.filter("isUndefined")(solt) ? "2" : solt;
    switch (type) {
      case "$":
        newv = "$ ";
        break;
      case "￥":
        newv = "￥ ";
        break;
    }
    newv = newv + v.toFixed(s).replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
    return newv;
  });

  //小数保留过滤器
  Vue.filter("number", function (v, solt) {
    var newv = "";
    var s = Vue.filter("isUndefined")(solt) ? "2" : solt;
    newv = newv + v.toFixed(s).replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
    return newv;
  });

  //日期格式化  v fmt:'yyyy-MM-dd'
  Vue.filter("date", function (v, fmt) {
    if (typeof (v) == 'object') {
      return Vue.prototype.dateFormat(v, fmt);
    }

    if (v == "" || Vue.filter("isUndefined")(v) || v == null) return "";
    return Vue.prototype.dateFormat(new Date(v.replace(/\-/g, '/')), fmt);
  });

  //过滤字典 根据dictid 查出数组
  Vue.filter("filterdict", function (dictid) {
    var dictid = Vue.filter("isUndefined")(dictid) ? "0" : dictid;
    var d = [];
    var dict = JSON.parse(localStorage.getItem("cachedict"));
    if (Vue.filter("isUndefined")(dict) || dict == null)
      return d;
    for (var i = 0; i < dict.length; i++) {
      if (dict[i].Dict_Type_Code == parseInt(dictid)) {
        d.push(dict[i]);
      }
    }
    return d;
  });
  //根据字典dictid  返回 固定对象 {text:'',value:''},{text:'',value:''}
  Vue.filter("filterdictbypick", function (dictid) {
    var dictid = Vue.filter("isUndefined")(dictid) ? "0" : dictid;
    var d = [];
    var dict = JSON.parse(localStorage.getItem("cachedict"));
    if (Vue.filter("isUndefined")(dict) || dict == null)
      return d;
    for (var i = 0; i < dict.length; i++) {
      if (dict[i].Dict_Type_Code == parseInt(dictid) && dict[i].IsDel == 0) {
        d.push({
          text: dict[i].Dict_Text,
          value: dict[i].Dict_Code
        });
      }
    }
    return d;
  });

  //根据字典dictid  返回 固定对象 {label:'',value:''},{label:'',value:''}
  Vue.filter("filterdictbychecklist", function (dictid) {
    var dictid = Vue.filter("isUndefined")(dictid) ? "0" : dictid;
    var d = [];
    var dict = JSON.parse(localStorage.getItem("cachedict"));
    if (Vue.filter("isUndefined")(dict) || dict == null)
      return d;
    for (var i = 0; i < dict.length; i++) {
      if (dict[i].Dict_Type_Code == parseInt(dictid)) {
        d.push({
          label: dict[i].Dict_Text,
          value: dict[i].Dict_Code
        });
      }
    }
    return d;
  });

  //取具体的数据文本
  Vue.filter("filterdictbyid", function (value, dictid) {
    var dictid = Vue.filter("isUndefined")(dictid) ? "0" : dictid;
    var dict = JSON.parse(localStorage.getItem("cachedict"));
    var d;
    if (Vue.filter("isUndefined")(dict) || dict == null)
      return d;
    for (var i = 0; i < dict.length; i++) {
      if (
        dict[i].Dict_Type_Code == parseInt(dictid) &&
        dict[i].Dict_Code == value
      ) {
        d = dict[i].Dict_Text;
        break;
      }
    }
    return d;
  });

  ///过滤 sourceid 的数据源
  Vue.filter("filtersource", function (sourceid) {
    // var sourceid = Vue.filter('isUndefined')(sourceid) ? "0" : sourceid;

    // if (angular.isUndefined(e))
    //     return;
    // return e[sourceid];
    return [];
  });

  ///过滤 sourceid 的数据源  并且value对应的值
  Vue.filter("filtersourcebyvalue", function (v, data) {
    var va = "",
      e = [];
    if (Vue.filter("isUndefined")(data))
      //data空值
      return e;
    for (var i = 0; i < data.length; i++) {
      if (data[i].value == v) {
        va = data[i]["text"];
        break;
      }
    }
    return va;
  });

  ///过滤用户名
  Vue.filter("filterUserName", function (data) {
    var tel1="*";
    for (var i = 0; i < data.length; i++) {
      if(i>1){
        tel1+="*";
      }
      var tel2 = data.replace(data.substring(1, data.length), tel1)
    }
    data = tel2;
    return data;
  });

  ///过滤手机号
  Vue.filter("filterphone", function (data) {
    if (data.length == 11) {
      var tel1 = data.replace(data.substring(3, 7), "****")
      data = tel1;
    }
    return data;
  });

};



// WEBPACK FOOTER //
// ./src/js/filter.js